<template>
  <el-container>
    <el-header>
      <el-tabs class="mt-3" v-model="type" @tab-click="handleTabClick" type="card">
        <el-tab-pane  :label="$t('密码管理')" name="password"></el-tab-pane>
        <el-tab-pane  :label="$t('组管理')" name="group"></el-tab-pane>
      </el-tabs>
    </el-header>
    <el-container>
      <el-aside width="200px" style="margin-left: 20px">
        <el-menu
            :default-active="activeMenu"
            :default-openeds="['groupMenu']"
            @select="handleMenuSelect"
            style="height: 800px;margin-top: 20px"
            v-loading="loading"
        >

          <!-- 分组 -->
          <el-submenu index="groupMenu">
            <template slot="title">我管理的组</template>
            <el-menu-item
                v-for="group in groupList"
                :key="group.id"
                :index="String(group.id)"
                style="display: flex; align-items: center;"
            >
              <span style="flex: 1; overflow: hidden; text-overflow: ellipsis;">{{ group.name }}</span>
              <el-dropdown style="position: absolute; right: 15px;">
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
                <el-dropdown-menu slot="dropdown" >
                  <span @click="handleEditGroup(group)">
                    <el-dropdown-item command="edit">
                      编辑
                    </el-dropdown-item>
                  </span>
                  <span @click="handleDeleteGroup(group.id)">
                    <el-dropdown-item command="delete">
                      删除
                    </el-dropdown-item></span>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <div>
          <div>
            <el-button type="primary" size="medium" @click="handleGroupAdd">{{ $t('新建组') }}</el-button>
            <el-button type="primary" size="medium" @click="inviteUser">{{ $t('邀请成员') }}</el-button>
<!--            <el-button type="primary" size="medium" style="float: right"-->
<!--                       @click = "$router.push('/password/password')">返回-->
<!--            </el-button>-->
          </div>
          <div style="margin-top: 20px">
            <el-form inline ref="form" :model="searchFrom" label-width="100px">
              <el-form-item :label="$t('用户昵称')" class="mb-0">
                <el-input  size="small" v-model="searchFrom.name"></el-input>
              </el-form-item>
              <el-form-item class="mb-0">
                <el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
                <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-dialog
              :title="dialogType === 'add' ? $t('添加组') : `编辑组 - ${groupFrom.name || ''}`"
              :visible.sync="dialogGroupVisible"
              width="500px"
              append-to-body
              @close="resetGroupForm">
            <el-form :model="groupFrom" :rules="formRules" ref="groupForm" label-width="100px">
              <el-form-item :label="$t('名称')" prop="name">
                <el-input v-model="groupFrom.name" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogGroupVisible = false">取消</el-button>
            <el-button type="primary" @click="submitGroupForm">确认</el-button>
          </span>
          </el-dialog>
          <el-table
              :data="userData"
              border
              style="width: 100%;margin-top: 10px"
              v-loading="loading"
          >
            <el-table-column fixed prop="id" label="ID" min-width="50"></el-table-column>
            <el-table-column prop="name" label="昵称" min-width="120"></el-table-column>
            <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
            <el-table-column prop="role_name" label="权限" min-width="120">
              <template v-slot = "scope">
                {{groupRole(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="100">
              <template v-slot="scope" >
                <el-button v-if="scope.row.user_id !== user.id"
                           type="text" size="small" @click="handleEditUser(scope.row)">
                  编辑
                </el-button>
                <el-button v-if="scope.row.user_id !== user.id" class="delete-btn"
                           type="text" size="small" @click="handleDeleteUser(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total">
            </el-pagination>
          </div>
          <el-dialog
              title="邀请成员"
              :visible.sync="dialogInviteVisible"
              width="600px"
              append-to-body
          >
            <el-form :model="inviteForm" label-width="80px" :rules = "formRules" ref="inviteForm">
              <!-- 新增：目标类型单选框 -->

              <!-- 动态切换的选择器 -->
              <el-form-item label="用户名称" prop="userTargets">
                <!-- 用户选择模式 -->
                <el-select
                    v-model="inviteForm.userTargets"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="输入用户名称搜索"
                    :remote-method="searchUsers"
                    :loading="loading"
                    class="share-target-select">
                  <el-option
                      v-for="user in userOptions"
                      :key="user.id"
                      :label="user.name"
                      :value="user.id"
                  >

                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 权限设置 -->
              <el-form-item label="权限" prop="permission">
                <el-radio-group v-model="inviteForm.permission">
                  <el-radio label="read">只读</el-radio>
                  <el-radio label="admin">管理</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogInviteVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmInvite">确认邀请</el-button>
          </span>
          </el-dialog>
          <el-dialog
              :title="`编辑成员 - ${userForm.name || ''}`"
              :visible.sync="editUserVisible"
              width="600px"
              append-to-body
          >
            <el-form :model="userForm" label-width="80px" :rules = "formRules" ref="userForm">

              <!-- 权限设置 -->
              <el-form-item label="权限" prop="access_level">
                <el-radio-group v-model="userForm.access_level">
                  <el-radio label="read">只读</el-radio>
                  <el-radio label="admin">管理</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="editUserVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmEditUser">确认修改</el-button>
          </span>
          </el-dialog>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>


  export default {
    name : 'group',
    data(){
      return{
        user : JSON.parse(window.sessionStorage.getItem('user')),
        activeMenu : 'userInfo',
        pagination : {
          currentPage : 1,
          pageSize : 10,
          total : 0
        },
        groupList : [],
        loading : false,
        dialogType : '',
        dialogGroupVisible : false,
        dialogInviteVisible : false,
        editUserVisible : false,
        groupFrom : {
          name : ''
        },
        formRules : {
          name : [
            {required: true, message: "请输入组名称", trigger: 'blur'}
          ],
          permission: [   // 邀请表单的权限字段
            { required: true, message: '请选择权限', trigger: 'change' }
          ],
          access_level: [ // 编辑表单的权限字段
            { required: true, message: '请选择权限', trigger: 'change' }
          ],
          userTargets: [
            {
              required: true,
              message: "请至少选择一个用户",
              trigger: 'change',
              type: 'array',  // 明确指定验证数组类型
              validator: (rule, value, callback) => {
                if (!value || value.length === 0) {
                  callback(new Error('请至少选择一个用户'));
                } else {
                  callback();
                }
              }
            }
          ]
        },
        userData : [],
        group_id : '',
        groupUserData : [],
        inviteForm : {
        },
        userOptions : [],
        userForm : {},
        searchFrom : {},
        type : 'group',
      }
    },
    created() {
      this.getGroupList()
    },
    methods : {
      handleMenuSelect(index){
        console.log(index)
        this.activeMenu = index
        this.pagination.currentPage = 1
        if(index === "userInfo"){
          this.getUserList()
        }else {
          const group_id = parseInt(index)
          this.getGroupUser(group_id)
        }
      },
      getGroupUser(group_id){
        this.axios.post('/admin/data/getGroupUser',{
          group_id : group_id,
          currentPage : this.pagination.currentPage,
          pageSize : this.pagination.pageSize,
          search : this.searchFrom
        },{
          token : true
        }).then(res => {
          console.log('res')
          console.log(res)
          if(res.status === 200 && res.data && res.data.code === 1){
            this.userData = res.data.data.list.list
            this.pagination.total = res.data.data.list.total
          }else {
            this.$message.error(res.data.msg)
          }
        })
      },
      getGroupList(){
        this.loading = true
        this.axios.post('/admin/data/userOwnGroup',{},{
          token : true
        }).then(res => {
          if(res.status === 200 && res.data && res.data.code === 1){
            this.groupList = res.data.data.list
            this.activeMenu = String(this.groupList[0].id)
            this.getGroupUser(parseInt(this.activeMenu))
          }else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      submitGroupForm(){
        this.$refs.groupForm.validate((valid) => {
          if (valid) {
            const apiUrl = this.dialogType === 'add'
                ? '/admin/data/addPasswordGroup'
                : '/admin/data/editPasswordGroup'
            this.axios.post(apiUrl,this.groupFrom,{
              token : true
            }).then(res => {
              if(res.status === 200 && res.data && res.data.code === 1){
                this.$message.success(res.data.msg)
              }else {
                this.$message.error(res.data.msg)
              }
            }).finally(() => {
              this.getGroupList()
              this.dialogGroupVisible = false
            })
          }
        })
      },
      handleGroupAdd(){
        this.dialogType = 'add'
        this.dialogGroupVisible = true
        this.resetGroupForm()
      },
      // 重置表单
      resetGroupForm() {
        if (this.$refs.groupFrom) {
          this.$refs.groupFrom.resetFields()
        }
        this.groupFrom = {
          id: null,
          name: '',
        }
      },
      handleDeleteGroup(id){
        this.$confirm(this.$t('确认删除该组吗？'), this.$t('system.prompt'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          type: 'warning'
        }).then(() => {
          this.axios.post('/admin/data/deletePasswordGroup',{
            group_id : id
          },{
            token : true
          }).then(res => {
            if(res.status === 200 && res.data && res.data.code === 1){
              this.$message.success(res.data.msg)
            }else {
              this.$message.error(res.data.msg)
            }
          }).finally(() => {
            this.getGroupList()
          })
        })

      },
      // handleGroupCommand(group, cmd) {
      //   console.log('handleGroupCommand', group, cmd)
      //
      //   return callback
      // },
      handleEditGroup(group) {
        this.dialogType = 'edit'
        this.groupFrom = {
          ...group
        }
        this.dialogGroupVisible = true
      },
      getUserList(){
        this.loading = true
        this.axios.post('/admin/data/getUserList',{
          currentPage : this.pagination.currentPage,
          pageSize : this.pagination.pageSize,
          search : this.searchFrom
        },{
          token : true
        }).then(res => {
          console.log('res')
          console.log(res)
          if(res.status === 200 && res.data && res.data.code === 1){
            this.userData = res.data.data.list.list
            this.pagination.total = res.data.data.list.total
          }else {
            this.$message.error(res.data.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      //处理每页条数变化
      handleSizeChange(val){
        this.pagination.pageSize = val
        this.pagination.currentPage = 1
        this.getUserList()
      },
      //处理页码变化
      handleCurrentChange(val){
        this.pagination.currentPage = val
        this.getUserList()
      },
      groupRole(row){
        if(row.access_level === 'admin'){
          return '管理'
        }else if(row.access_level === 'read'){
          return '只读'
        }
      },
      inviteUser(){
        this.searchUsers()
        this.inviteForm = {}
        this.dialogInviteVisible = true
      },
      searchUsers(query) {
        this.loading = true;
        this.axios.post('/admin/data/getUser', {
          search : query
        }, {
          token: true
        }).then(res => {
          if (res.status === 200) {
            this.userOptions = res.data.data.list;
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      confirmInvite(){
        this.$refs.inviteForm.validate((valid) => {
          if (valid) {
            this.inviteForm.group_id = parseInt(this.activeMenu)
            this.axios.post('/admin/data/addGroupUser',this.inviteForm,{
              token : true
            }).then(res => {
              if(res.status === 200 && res.data && res.data.code === 1){
                this.$message.success(res.data.msg)
              }else {
                this.$message.error(res.data.msg)
              }
            }).finally(() => {
              this.getGroupUser(parseInt(this.activeMenu))
              this.dialogInviteVisible = false
            })
          }
        })

      },
      handleEditUser(row){
        this.editUserVisible = true
        this.userForm = {
          ...row
        }
      },
      confirmEditUser(){
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            this.axios.post('/admin/data/editUserAccess',this.userForm,{
              token : true
            }).then(res => {
              if(res.status === 200 && res.data && res.data.code === 1){
                this.$message.success(res.data.msg)
              }else {
                this.$message.error(res.data.msg)
              }
            }).catch(error => {
              this.$message.error(error)
            }).finally(() => {
              this.getGroupUser(parseInt(this.activeMenu))
              this.editUserVisible = false
            })
          }
        })

      },
      handleDeleteUser(row){
        this.$confirm(this.$t('确认将用户移出该组吗？'), this.$t('system.prompt'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          type: 'warning'
        }).then(() => [
            this.axios.post('/admin/data/deleteGroupUser',{user_id : row.user_id},{
              token : true
            }).then(res => {
              if(res.status === 200 && res.data && res.data.code === 1){
                this.$message.success(res.data.msg)
              }else {
                this.$message.error(res.data.msg)
              }
            }).catch(error => {
              this.$message.error(error)
            })
        ]).finally(() => {
          this.editUserVisible = false
        })
      },
      searchEvent() {
        this.pagination.currentPage = 1  // 搜索时重置到第一页
        this.getGroupUser(parseInt(this.activeMenu))
      },
      // 重置搜索条件
      clearSearch() {
        this.searchFrom = {
          name : ''
        }
        this.searchEvent()  // 重置后重新加载数据
      },
      handleTabClick(tab) {
        const routeMap = {
          password: '/password/password',
          group: '/password/group',
        }

        if (routeMap[tab.name] && this.$route.path !== routeMap[tab.name]) {
          this.$router.push(routeMap[tab.name])
        }
      },
    }
  }
</script>
<style scoped>
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.delete-btn {
  color: #F56C6C;
}
</style>